import { create } from 'zustand';

interface FullscreenState {
  isFullscreen: boolean;
}

interface FullscreenActions {
  setFullscreen: (isFullscreen: boolean) => void;
  toggleFullscreen: () => void;
}

export type FullscreenStore = FullscreenState & FullscreenActions;

// Session-only, in-memory state (no persist): survives client-side navigation but resets on reload.
// NavigationLayout owns the DOM side effects; this store only holds the flag.
export const useFullscreenStore = create<FullscreenStore>((set, get) => ({
  isFullscreen: false,

  setFullscreen: (isFullscreen) => set({ isFullscreen }),
  toggleFullscreen: () => set({ isFullscreen: !get().isFullscreen }),
}));
